<template lang="html">
  <div class="py-5 px-1 emergency-container">
    <h2 class="text-danger h1 text-center text-uppercase">Emergency</h2>
    <div v-if="isMobile" class="d-flex align-items-center justify-content-center">
      <a class="text-light h3" href="tel:+2010000000000">+2010000000000</a>
    </div>
    <div v-if="!isMobile" class="d-flex align-items-center justify-content-center flex-column">
      <input value="+2010000000000" class="text-center h2 py-1 text-light rounded border-0" @click="copy($event)"/>
      <span v-if="isCopied" class="badge badge-success ml-1">Copied</span>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      isMobile: false,
      isCopied: false
    }
  },
  mounted(){
    if(/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true
    }
  },
  methods:{
    copy(e){
     e.preventDefault();
     e.target.select();
     document.execCommand('copy');
     this.isCopied = true
    }
  }
}
</script>

<style lang="css" scoped>
.emergency-container{
  background: #1f273c;
}
.emergency-container input{
  background: transparent;
  cursor: pointer;
}
</style>
